import {SeriesNoticeType} from '../generated/types';

export function createSeriesNoticeType(n_type: string): SeriesNoticeType {
  switch (n_type) {
    case 'N':
      return SeriesNoticeType.Notice;
    case 'S':
      return SeriesNoticeType.AuthorSay;
    case 'E':
      return SeriesNoticeType.Event;
    case 'R':
      return SeriesNoticeType.Rest;
    case 'D':
      return SeriesNoticeType.Down;
    default:
      return SeriesNoticeType.Unknown;
  }
}
